import React, { useState } from "react";
import { Row, Col, Slider, Button, Divider } from "antd";
import "./CalculatorROI.css";


const HireCounts = {
     0: '0 hires',
     100: '100 hires',
};
const Spend = {
     0: '$0',
     100000: '$100,000',
};
const CostPerHire = {
     0: '$0',
     100000: '$100,000',
};

export const CalculatorROI = () => {
     // const [currentValue, setCurrentValue] = useState(0)
     const [hireCountsNumber, setHireCountsNumber] = useState(0)
     const [hireSpendValue, setHireSpendValue] = useState(0)
     const [hireCostValue, setHireCostValue] = useState(0)
     return (
          <>
               <section className="ground-color-ashes calculator-metro-wrap ">
                    <div className="mtp-container">

                         <div className="section-header-lg calculator-metro-section-header ">
                              <h3 className="section-header-lg-primary-heading  text-color-alpha fw-700">
                                   Metro ROI Calculator
                              </h3>
                              <p className="section-header-lg-secondary-text  text-color-bravo fw-400">
                                   Quickly understand the real ROI/value add that  business/organisation can gain from the Metropolis platform.
                              </p>
                         </div>

                         <Row gutter={[24, 24]}>

                              {/* _BEGIN > METRO CALCULATOR ROI < SHB & RIA */}
                              <Col span={16}>
                                   <div className="calculator-range-wrapper">
                                        <div className="calculator-range-items-wrapper">
                                             <div className="range-slider">
                                                  <div className="calculator-range-flex-question">
                                                       <h6>How many hires do you have per year?</h6>
                                                       <p className="flex-auto-0">{hireCountsNumber}</p>
                                                  </div>
                                                  <Slider className="mtp-range-slider" marks={HireCounts} onChange={(value) => { setHireCountsNumber(value) }} defaultValue={0} min={0} max={100} />
                                             </div>
                                        </div>

                                        <Divider className="mtp-range-divider" />

                                        <div className="calculator-range-items-wrapper">
                                             <div className="range-slider">
                                                  <div className="calculator-range-flex-question">
                                                       <h6>How many hires do you have per year?</h6>
                                                       <p className="flex-auto-0">${hireSpendValue}</p>
                                                  </div>
                                                  <Slider className="mtp-range-slider" marks={Spend} onChange={(value) => { setHireSpendValue(value) }} defaultValue={0} min={0} max={100000} />
                                             </div>
                                        </div>

                                        <Divider className="mtp-range-divider" />

                                        <div className="calculator-range-items-wrapper">
                                             <div className="range-slider">
                                                  <div className="calculator-range-flex-question">
                                                       <h6>How many hires do you have per year?</h6>
                                                       <p className="flex-auto-0">${hireCostValue}</p>
                                                  </div>
                                                  <Slider className="mtp-range-slider" marks={CostPerHire} onChange={(value) => { setHireCostValue(value) }} defaultValue={0} min={0} max={100000} />
                                             </div>
                                        </div>

                                        <div className="calculator-range-estimate flex-center">
                         
                                             <Button className="CustomButton mtp-button" type="prime" > Estimate </Button>
                                        </div>
                                   </div>
                              </Col>
                              {/* _ENDS > METRO CALCULATOR ROI < SHB & RIA */}

                              {/* calculator-metro-result-summary start //RIA */}
                              <Col span={8}>
                                   <div className="calculator-metro-result-summary">
                                        <p className="calculator-metro-result-summary-title fw-600">Result Summary</p>

                                        <Divider className="calculator-metro-result-summary-divider" />

                                        <div className="calculator-metro-result-summary-price flex-center flex-column">
                                             <h4 className="fw-700">$250.00</h4>
                                             <span className="fw-500">You Would Save with Metropolis</span>
                                             <div className="orangeDivider"></div>
                                        </div>
                                        <div className="calculator-metro-result-summary-cost-wrap">
                                             <div className="result-cost-left-content">
                                                  <p className="fw-500">Cost of a yearly Metropolis subscription</p>
                                             </div>
                                             <div className="result-cost-right-content">
                                                  <span className="fw-600">$250.00</span>
                                                  <p className="fw-500 text-color-earth">You saved $25</p>
                                             </div>
                                        </div>

                                        <Divider className="calculator-metro-result-summary-divider" />

                                        <div className="calculator-metro-result-summary-cost-wrap">
                                             <div className="result-cost-left-content">
                                                  <p className="fw-500">Cost per hire if you switched to Metropolis</p>
                                             </div>
                                             <div className="result-cost-right-content">
                                                  <span className="fw-600">$112.50</span>
                                                  <p className="fw-500 text-color-earth">You saved $12.50</p>
                                             </div>
                                        </div>
                                   </div>
                              </Col>
                              {/* calculator-metro-result-summary end //RIA */}
                         </Row>
                    </div>
               </section>
          </>
     )
}